module.exports = __webpack_public_path__ + "static/redwagon.94206027.jpg";